@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  font-size: var(--body-size);
}

gz-side-menu {
  .wrapper {
    display: flex;
    flex-direction: column;

    #integration-name {
      padding: calc(var(--spacer) * 6) calc(var(--spacer) * 3) calc(var(--spacer) * 2);
    }

    .content {
      flex: 1;
      overflow: auto;

      .integration-description {
        &::part(label) {
          text-transform: uppercase;
        }

        &::part(content) {
          white-space: normal;
        }
      }

      .integration-description,
      .integration-details {
        height: auto;
        padding: var(--spacer) calc(var(--spacer) * 3) calc(var(--spacer) * 2);
      }
      .integration-company {
        height: auto;
        padding: 0 calc(var(--spacer) * 3);
      }
      .integration-description,
      .integration-details {
        padding-bottom: 0;
      }
      .integration-details,
      .integration-company {
        gz-button {
          &::part(button) {
            padding: 0;
          }
          &::part(button-text) {
            font-size: var(--body-size);
          }
        }
      }
      .integration-sensor {
        padding: var(--spacer) calc(var(--spacer) * 3);
        border-top: 1px solid var(--chart-101-pressed-dividers);

        &::part(label) {
          text-transform: uppercase;
        }

        .tooltip-subscriptionId {
          cursor: pointer;
        }

        .expandable-text {
          word-wrap: break-word;
          overflow-wrap: anywhere;
          white-space: normal;
          width: 100%;
        }

        .integration-sensor-error {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: 100%;
          font-style: italic;
          color: var(--red-alert-500-severe);
        }

        .expand-button {
          margin-top: calc(var(--spacer) / 2);
          align-self: flex-start;
        }

        .tooltip-labeled-value {
          display: block;
        }
      }
    }

    #integration-actions {
      padding: var(--spacer) calc(var(--spacer) * 3);
      border-top: 1px solid var(--chart-101-pressed-dividers);

      gz-button {
        margin-right: 16px;
      }
    }
  }
}

.warning-sensor-delete {
  margin-top: 20px;
}

.integration-sensor-gateway-element {
  padding-top: var(--spacer);
}

.integration-sensor-subnet-element {
  padding-top: var(--spacer);
}

gz-labeled-content[class='gz-labeled-content-indent'] {
  &::part(content) {
    padding-left: calc(var(--spacer) * 2);
  }

  gz-labeled-content {
    --label-width-percentage: 37%;
    --value-width-percentage: 63%;
    margin-bottom: -2px;
  }
}

show-more-items[class='show-more-component'] {
  --show-more-content-padding: var(--spacer) calc(var(--spacer) * 2);
  --show-more-label-color: var(--text-color-on-light-90);
}

#integration-common-data {
  > div {
    padding: 0 calc(var(--spacer) * 3) var(--spacer) calc(var(--spacer) * 3);
  }
}

gz-labeled-content {
  --padding-value: calc(var(--spacer) * 2);
}

gz-labeled-content[class*='integration-sensor']::part(container) {
  margin-bottom: 0;
}

.integration-sensor-network {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
